import { FC, useMemo } from 'react';
import Layout from 'src/components/Layout';

import useEnterInvoices from 'src/hooks/useEnterInvoices';
import useSplitter from 'src/hooks/useSplitter';
import EnterInvoicePreview from 'src/sections/enter_invoice/EnterInvoicePreviewSection';
import AttachDocumentContextProvider from '../attach_document/AttachDocumentContext';
import EnterInvoiceNavbar from './EnterInvoiceNavBar';
import OcrInvoicePreviewSection from './OcrInvoicePreviewSection';

interface ShowScansReceiptProps {
  main: JSX.Element;
}

const ShowScansInvoice: FC<ShowScansReceiptProps> = ({ main }) => {
  const {
    showPreview,
    selectedInvoicePoRow,
    invoiceNumber,
    selectedInvoiceRow,
    selectedSupplierInvoiceRow,
    isOcrRedirect,
  } = useEnterInvoices();

  const PreviewSection = useMemo(
    () =>
      showPreview ? isOcrRedirect ? <OcrInvoicePreviewSection /> : <EnterInvoicePreview /> : <></>,
    [isOcrRedirect, showPreview]
  );
  const FullPage = useSplitter(main, PreviewSection, showPreview);
  return (
    <AttachDocumentContextProvider
      isInvoice
      poId={selectedInvoicePoRow?.poId}
      invoiceNumber={invoiceNumber.value}
      receiptId={selectedInvoiceRow?.receiptId}
      supplierId={selectedSupplierInvoiceRow.offlineSupplierId}
      isEnterReceipts={false}
      isNewTab={false}
    >
      <Layout>
        <EnterInvoiceNavbar />
        {FullPage}
      </Layout>
    </AttachDocumentContextProvider>
  );
};

export default ShowScansInvoice;
